<div class="col-md-12 mb-30" >
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0">Proficiency Test Stage Information '{{inner_AzmoonMaharatMain.title}}' for Customer '{{inner_AzmoonMaharatMain.name}}' </h5>
      <br />
      <br />
      <div class="row">
        <div class="form-group col-md-6">
          <button *ngIf="!Procssing" type="button" (click)="ReadData_AzmoonMaharat()" class="btn btn-info"
            style="margin-right: 5px;"><i class="fa  fa-search"></i> Search </button>
          <button (click)="onBack()" type="button" class="btn btn-warning"><i class="fa fa-mail-reply"></i> Back
          </button>
          <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Title</th>
              <th>Start Date</th>
              <th>End Date</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_AzmoonMaharat
            |filter:Filter_title:'title'
            | paginate
                    : {
                        id: 'DataList_FeildTable',
                        itemsPerPage: 50,
                        currentPage: page,
                        totalItems: (DataList_AzmoonMaharat|filter:Filter_title:'title').length
                      }
            ">
              <td>{{DataList_AzmoonMaharat.indexOf(item)+1}}</td>
              <td>{{item.title}}</td>
              <td>{{item.startDate}}</td>
              <td>{{item.endDate}}</td>
              <td>
                <div class="btn-group  " role="group" aria-label="Button group with nested dropdown">
                  <div *ngIf="!item.DeletingProccess" class="btn-group" role="group">
                    <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                      data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      Actions
                    </button>
                    <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                      <a *ngIf="inner_Del_Filter=='0'" style="cursor: pointer;" (click)="openModal(template,item)" class="dropdown-item" ><i class="fa  fa-edit"></i>
                        Edit Date
                      </a>
                      <a style="cursor: pointer;" (click)="openModalFile(templateFile,item)" class="dropdown-item" ><i class="fa  fa-file"></i>
                        Manage Files
                      </a>
                      <a style="cursor: pointer;" (click)="openModalFile1(templateFile1,item)" class="dropdown-item" ><i class="fa  fa-eye"></i>
                        Customer Files
                      </a>
                    </div>
                  </div>

                  <div *ngIf="item.DeletingProccess">
                    <img src="assets/Loading.gif" style="width: 25px;" />
                  </div>
                </div>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <pagination-controls id="DataList_FeildTable" nextLabel="Next" previousLabel="Previous" (pageChange)="page = $event">
    </pagination-controls>
  </div>
</div>


<ng-template #template>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Edit Stage Dates  '{{Data_Seleted_Delete.title}}' </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Delete.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>

  <div class="modal-body">
    <form [formGroup]="AzmoonMaharatForm">
      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1"> Start Date </label>
          <input formControlName="startDate" type="text" class="form-control" #startDateInput
            placeholder="Type here...">
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
            [dateFormat]="'jYYYY-jMM-jDD'" [dateInitValue]="false" [input]="startDateInput"></ng-persian-datepicker>
          <small *ngIf="!get_Form_startDate().valid && get_Form_startDate().touched"
            class="form-text text-muted MyErrorRedColor">Please enter a start date.</small>
        </div>
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1"> End Date </label>
          <input formControlName="endDate" type="text" class="form-control" #endDateInput
            placeholder="Type here...">
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
            [dateFormat]="'jYYYY-jMM-jDD'" [dateInitValue]="false" [input]="endDateInput"></ng-persian-datepicker>
          <small *ngIf="!get_Form_endDate().valid && get_Form_endDate().touched"
            class="form-text text-muted MyErrorRedColor">Please enter an end date.</small>
        </div>
      </div>
    </form>
  </div>

  <div class="modal-footer">
    <button *ngIf="!InProccessing" type="button" (click)="SubmitRequestSignIn()" [disabled]="!AzmoonMaharatForm.valid"
    class="btn btn-success" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Register Information </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Delete.hide()">Close</button>
  </div>
</ng-template>


<ng-template #templateFile>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Stage File Management  '{{Data_Seleted_Delete.title}}' </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_File.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>

  <div class="modal-body">
    <form [formGroup]="AzmoonMaharatFileForm" *ngIf="inner_Del_Filter=='0'">
      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1"> Title </label>
          <input formControlName="title" type="text" class="form-control" placeholder="Type here...">
          <small *ngIf="!get_FormFile_title().valid && get_FormFile_title().touched"
            class="form-text text-muted MyErrorRedColor">Please enter a title.</small>
        </div>
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1"> File </label>
          <input #file_template (change)="UploadTemplate(file_template.files)" type="file" class="form-control"
            placeholder="Type here...">
          <small *ngIf="!get_FormFile_templateSrc().valid && get_FormFile_templateSrc().touched"
            class="form-text text-muted MyErrorRedColor">Please select a file.</small>
        </div>
      </div>

      <button *ngIf="!InProccessing" type="button" (click)="SubmitRequestSignInFile()" [disabled]="!AzmoonMaharatFileForm.valid"
        class="btn btn-success" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Add File </button>
    </form>

    <br />
    <hr />
    <br />

    <div class="table-responsive">
      <table class="mb-0 table table-bordered table-3 text-center table-striped">
        <thead style="background-color: #489b39; color: white;">
          <tr>
            <th>#</th>
            <th>Title</th>
            <th>File</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of Data_Seleted_Delete.file">
           <td>{{Data_Seleted_Delete.file.indexOf(item)+1}}</td>
            <td>{{item.title}}</td>
            <td>
              <a class="btn btn-danger" href="{{BaseUrl}}{{item.templateSrc}}" target="_blank">
                View File
              </a>
            </td>
            <td>
              <button *ngIf="inner_Del_Filter=='0'" (click)="DeleteRequestSignInFile(item)" type="button" class="btn btn-danger"> Delete </button>
            </td>

          </tr>
        </tbody>
      </table>
   </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="modalRef_File.hide()">Close</button>
  </div>
</ng-template>

<ng-template #templateFile1>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Stage Response Files  '{{Data_Seleted_Delete.title}}' </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_File1.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>

  <div class="modal-body">

    <div class="table-responsive">
      <table class="mb-0 table table-bordered table-3 text-center table-striped">
        <thead style="background-color: #489b39; color: white;">
          <tr>
            <th>#</th>
            <th>Title</th>
            <th>File</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of Data_Seleted_Delete.file1">
           <td>{{Data_Seleted_Delete.file1.indexOf(item)+1}}</td>
            <td>{{item.title}}</td>
            <td>
              <a class="btn btn-danger" href="{{BaseUrl}}{{item.templateSrc}}" target="_blank">
                View File
              </a>
            </td>
          </tr>
        </tbody>
      </table>
   </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="modalRef_File1.hide()">Close</button>
  </div>
</ng-template>
